<template>
  <div class="table-wrapper">
    <el-table
      :data="dataSource"
      @row-click="rowClick"
      @sort-change="sortChange"
      @cell-click="cellClick"
      @selection-change="selectionChange"
      :height="height"
      ref="myTable"
      style="width: 100%"
    >
      <template v-for="(item, index) in columns">
        <template v-if="item.show !== false">
          <slot v-if="item.slotName" :name="item.slotName"></slot>
          <el-table-column
            v-else
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :width="item.width"
            :min-width="item.minWidth"
            :fixed="item.fixed"
            :show-overflow-tooltip="item.showOverflowTooltip"
            :key="index"
          >
            <template slot="header" slot-scope="scope">
              <span>{{ scope.column.label }}</span>
              <el-tooltip
                v-if="item.tooltip"
                effect="dark"
                :content="item.tooltip"
                placement="top"
              >
                <i
                  class="el-icon-warning-outline"
                  style="margin-left: 5px; cursor: pointer; color: #E6A23C;"
                ></i>
              </el-tooltip>
            </template>
            <!-- <template slot-scope="{ row }"> -->
            <template slot-scope="{ row, $index }">
              <template v-if="row.isEdit === true">
                <template v-if="row[item.prop].type === 'input'">
                  <el-input
                    v-model="row[item.prop].value"
                    :maxlength="row[item.prop].maxlength"
                    :disabled="row[item.prop].disabled"
                    :style="{ width: row[item.prop].width + 'px' }"
                    @change.native="cellChange(row[item.prop], row, $index)"
                    @input="cellChange(row[item.prop], row, $index)"
                  />
                </template>
                <template v-else-if="row[item.prop].type === 'select'">
                  <el-select
                    v-model="row[item.prop].value"
                    :style="{ width: row[item.prop].width + 'px' }"
                    :filterable="row[item.prop].filterable"
                    :disabled="row[item.prop].disabled"
                    :popper-append-to-body="true"
                    :clearable="row[item.prop].clearable"
                    :placeholder="
                      row[item.prop].placeholder || $t('pleaseChoose')
                    "
                    @change="cellChange(row[item.prop], row, $index)"
                  >
                    <el-option
                      v-for="_item in row[item.prop].options"
                      :key="
                        row[item.prop].valueName
                          ? _item[row[item.prop].valueName]
                          : _item.value
                      "
                      :label="
                        row[item.prop].labelName
                          ? _item[row[item.prop].labelName]
                          : _item.name
                      "
                      :value="
                        row[item.prop].valueName
                          ? _item[row[item.prop].valueName]
                          : _item.value
                      "
                    >
                    </el-option>
                  </el-select>
                </template>
                <template v-else-if="row[item.prop].type === 'timePicker'">
                  <el-time-picker
                    v-model="row[item.prop].value"
                    value-format="HH:mm"
                    format="HH:mm"
                    @change="cellChange(row[item.prop], row, $index)"
                    :placeholder="
                      row[item.prop].placeholder || $t('pleaseChoose')
                    "
                  >
                  </el-time-picker>
                </template>
                <template v-else>
                  {{ row[item.prop].value }}
                </template>
                <template v-if="row[item.prop].btn">
                  <div
                    class="table_btn"
                    @click="cellClickBtn(row[item.prop], row, $index)"
                  >
                    {{ $t("save") }}
                  </div>
                </template>
              </template>
              <template v-else>
                {{ row[item.prop] }}
              </template>
            </template>
          </el-table-column>
        </template>
      </template>
      <p slot="append" class="load-more" v-if="showLoadMore">
        <span @click="loadMore">{{ $t("loadMore") }}</span>
      </p>
      <p slot="append" class="load-more no-more" v-if="showNoMore">
        {{ $t("noMoreData") }}
      </p>
      <template slot="empty">
        <noData :height="height" />
      </template>
    </el-table>
  </div>
</template>

<script>
export default {
  name: "Table",
  props: {
    columns: Array,
    dataSource: Array,
    showLoadMore: {
      type: Boolean,
      default: false
    },
    showNoMore: {
      type: Boolean,
      default: false
    },
    height: {
      type: Number
    }
  },
  beforeUpdate() {
    this.$refs.myTable.doLayout();
  },
  methods: {
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    sortChange(column, prop, order) {
      this.$emit("sort-change", column, prop, order);
    },
    cellClick(row, column, cell, event) {
      this.$emit("cell-click", row, column, cell, event);
    },
    cellChange(cellData, rowData, index) {
      if (cellData.change) {
        cellData.change(cellData, rowData, index);
      }
    },
    cellClickBtn(cellData, rowData, index) {
      if (cellData.btn) {
        cellData.btn(cellData, rowData, index);
      }
    },
    selectionChange(val) {
      this.$emit("selectionChange", val);
    },
    loadMore() {
      this.$emit("loadMore");
    }
  }
};
</script>

<style lang="less">
.el-table .cell {
  // overflow: unset;
  color: @color-primary;
  text-align: center;
}
.el-table__header-wrapper {
  font-family: baseFont;
  font-weight: normal;
  thead th .cell {
    text-transform: uppercase !important;
    word-wrap: break-word;
    word-break: break-word;
    .el-checkbox {
      margin-left: 1px !important;
    }
  }
}
// .el-table .cell
.el-table th > .cell {
  font-family: baseFont;
  font-weight: normal;
  text-transform: uppercase !important;
  word-wrap: break-word;
  word-break: break-word;
  text-align: center;
  .el-checkbox {
    margin-left: 1px !important;
  }
}
.load-more {
  color: @color-blue;
  text-align: center;
  line-height: 30px;
  span {
    cursor: pointer;
  }
}
.no-more {
  color: @color-primary;
}
// .el-table td {
//   text-align: center;
//   color: @color-primary;
//   border-bottom: 6px solid #F3F5F9;
//   padding: 10px 0;
//   cursor: pointer;
// }
// .el-table__row {
//   margin: 10px 0;
// }
// .el-table__header-wrapper {
//   background-color: #F3F5F9;
// }
// .el-table::before {
//   display: none;
// }
// .el-table th {
//   text-align: center;
//   background-color: #F3F5F9;
//   padding: 20px 0;
//   font-size: 16px;
//   font-weight: normal;
// }
// .el-table thead tr {
//   background-color: #F3F5F9;
// }
// .el-table th.is-leaf {
//   border-bottom: none;
// }
// .el-table .ascending .sort-caret.ascending {
//   border-bottom-color: @color-blue;
// }
.table_btn {
  text-align: center;
  height: 26px;
  line-height: 26px;
  padding: 0 5px;
  border: none;
  border-radius: 2px;
  outline: none;
  background-color: #83909b;
  color: #fff;
  background-color: #67c23a;
  width: 64px;
  position: absolute;
  top: 15px;
  left: 152px;
}
</style>
